import api from "./api";


export const UpdateProductOption = async (optionId, payload) => {
  return api
    .put(`ProductOptions/${optionId}`, payload)
    .then(res => res.data);
};


export const GetProductOptions = async (productId) => {
  return api
    .get(`Product/${productId}/options`)
    .then(res => res.data);
};

export const DeleteProductOption = async (optionId) => {
  return api.delete(`ProductOptions/${optionId}`).then(res => res.data);
};

// יצירה של וריאציה חדשה למוצר
export const AddProductOption = async (payload) => {
  // payload חייב לכלול לפחות: productId, optionType, value, extraPrice (ואם יש quantity)
  return api.post(`ProductOptions`, payload).then(res => res.data);
};